import React from 'react';
import PageMeta from 'src/components/10-atoms/seo/PageMeta';
import Page from 'src/components/templates/page/Page.template';
import PageSearchBar from 'src/components/templates/page/PageSearchBar.template';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import useCallbackWithCtx from 'src/hooks/useCallbackUtils/useCallbackWithCtx';
import Analytics from 'src/lib/analytics';
import useI18n from 'src/modules/translations/hooks/useI18n';
import { isWeb } from 'src/utils/platform';
import QuestionList from '../../containers/QuestionList';
import buildEPQuestionNavParams from '../../navigation/buildEPQuestionNavParams';
import useData from './useData';
const pageAnalytics = Analytics.event.builder().setPage('EP_QuestionSearch');
const QuestionSearch = ({ navigation }) => {
    const [{}] = useTheme(stylesGenerator);
    const { translate } = useI18n();
    const [state, actions] = useData();
    const buildQuestionNavParams = useCallbackWithCtx((ctx, question, index) => buildEPQuestionNavParams({
        ...(!isWeb && {
            question,
        }),
        questionID: question.id,
        navigatedFrom: 'SEARCH_QUESTIONS',
        navigationData: {
            query: ctx.state.search.deferredVal,
            sequence: index,
        },
    }), { state });
    const trackQuestionPress = useCallbackWithCtx(() => {
        pageAnalytics
            .setWidget('QuestionSearchList')
            .setTarget('Question')
            .click();
    }, []);
    const getQuestionTo = useCallbackWithCtx((ctx, question, index) => ({
        screen: 'EP_Question',
        params: ctx.buildQuestionNavParams(question, index),
    }), { buildQuestionNavParams });
    return (React.createElement(Page, null,
        React.createElement(PageMeta, { title: "Search COC Exam Questions", description: "Search across all COC written and oral exam questions.", canonical: "exam-prep/question-search", jsonLd: {
                '@context': 'https://schema.org',
                '@graph': [
                    {
                        '@type': 'SearchResultsPage',
                        name: 'COC Exam Question Search',
                        description: 'Search across all COC written and oral exam questions.',
                        url: 'https://marinesamraj.com/exam-prep/question-search',
                    },
                    {
                        '@type': 'WebSite',
                        name: 'MarineSamraj',
                        url: 'https://marinesamraj.com',
                        potentialAction: {
                            '@type': 'SearchAction',
                            target: 'https://marinesamraj.com/exam-prep/question-search?q={search_term_string}',
                            'query-input': 'required name=search_term_string',
                        },
                    },
                ],
            } }),
        React.createElement(PageSearchBar, { value: state.search.value, onChange: actions.search.change, onClear: () => actions.search.change(''), placeholder: translate('Search for a question...'), onBackPress: navigation.goBack }),
        React.createElement(QuestionList, { variant: "question-search", queryState: state.listQuery, queryActions: actions.listQuery, variables: state.listQueryVars, onQuestionPress: trackQuestionPress, getQuestionTo: getQuestionTo })));
};
const stylesGenerator = createThemedStyle(({}) => ({}));
export default QuestionSearch;
